import React from 'react';
import axios, { CancelTokenSource } from 'axios';

import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';
import BouncedEmailList from './bouncedEmailList/BouncedEmailList';

import { IGroupMember } from '../../store/group/groupState';
import * as groupService from '../../services/group';

export interface IOwnProps {
    groupId: string;
}

export interface IRouterParams {
    groupId: string;
}

interface IOwnState {
    cancelToken: CancelTokenSource;
    members: IGroupMember[];
    isLoading: boolean;
}

type State = IOwnState;
type Props = IOwnProps;

class MaintenanceIndex extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            cancelToken: axios.CancelToken.source(),
            members: [],
            isLoading: true,
        }

        this.fetchData();
    }

    public componentWillUnmount() {
        this.state.cancelToken.cancel();
    }

    private async fetchData() {
        const members = await groupService.getBouncedGroupMembers(this.props.groupId, this.state.cancelToken);

        this.setState({
            members: members,
            isLoading: false
        });
    }

    private deleteFromList(diNumber: number) {
        const newMembersList = this.state.members.filter((m) => m.diNumber !== diNumber);

        this.setState({
            members: newMembersList
        });
    }

    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md">
                        <div className="banner-title">
                            <h1>Fejlende email leverancer</h1>
                        </div>
                        {this.state.isLoading ? <div className="w--md"><Spinner size={SpinnerSize.Large} /></div> :
                            <>
                                {this.state.members.length > 0 &&
                                    <BouncedEmailList deleteFromList={this.deleteFromList.bind(this)} members={this.state.members}></BouncedEmailList>
                                }
                                {this.state.members.length === 0 &&
                                    <div className="w--md">
                                        <h2 className="practical__headline">Ingen afviste e-mails at vedligeholde, alt er under kontrol.</h2>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }
}

export default MaintenanceIndex;